import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchOverlay, editOverlay, deleteOverlay, clearOverlayErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import Alert from '../components/home/Alert';
import EditOverlay from '../components/overlays/EditOverlay'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  overlay: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class OverlaysEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      overlay: {}
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    this.props.dispatch(fetchOverlay(this.props.overlayId))
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.overlay && this.props.overlay.id !== nextProps.overlay && nextProps.overlay.id) {
      this.setState({overlay: nextProps.overlay})}
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.overlay && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Overlay edited succesfully!',
        error: false,
      });
    }
  }
  deleteOverlay(data) {
    const overlays = this.props.overlays;
    // overlays.delete = true;
    this.setState({ overlays });
    this.props.dispatch(deleteOverlay(data));
    browserHistory.push('/overlays');
  }
  saveEditOverlay(overlay) {
    this.setState({
      edited: true,
    })
    this.props.dispatch(editOverlay(overlay));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearOverlayErrors());
    if (!this.state.error) {
      browserHistory.push('/overlays');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    }
    return (
      <div className="overlays component" style={authPage}>
        <h2>Edit Overlays</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditOverlay
            overlay={this.state.overlay}
            onSave={data => this.saveEditOverlay(data)}
            onDelete={data => this.deleteOverlay(data)}
          />
        </div>
      </div>
    );
  }
}

OverlaysEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OverlaysEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    overlay: state.overlays && state.overlays.overlay && state.overlays.overlay,
    overlayId: ownProps.params.id,
    // error: state.overlays.error,
  };
}

export default withRouter(connect(mapStateToProps)(OverlaysEditPage));



// WEBPACK FOOTER //
// ./src/containers/OverlaysEditPage.js